import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createFilter: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createFilter: {
		id: 'create-filter-button.create-filter',
		defaultMessage: 'Create filter',
		description: 'Text on the button to create a new filter.',
	},
});
export default messages;
